import { ReactElement } from 'react';

import { IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';
import { Row } from 'components/layout';

import styles from './SaveChangesModal.module.scss';

export const SaveChangesModal = ({
  isOpen,
  onClose,
  onSave,
  setOpen,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  setOpen: (value: boolean) => void;
}): ReactElement => {
  return (
    <>
      <Modal
        contentClassName={styles.SaveChangesModal}
        isOpen={isOpen}
        onRequestClose={() => setOpen(false)}
      >
        <Row className={styles.modalHeader} justify="center">
          <IconButton
            size="small"
            iconName="close"
            className={styles.cancelIcon}
            onClick={onClose}
          />
          <div className={styles.contentSection}>
            <p className={styles.contentSectionIcon}>❓</p>
            <p className={styles.contentSectionTitle}>Save changes</p>
            <p className={styles.contentSectionDescription}>
              Your profile changes are not saved. Do you want to save changes
              before closing?
            </p>
            <ButtonV3
              type="button"
              className={styles.contentSectionSaveButton}
              onClick={onSave}
            >
              Save
            </ButtonV3>

            <ButtonV3
              color={'secondary'}
              onClick={onClose}
              className={styles.contentSectionCloseButton}
            >
              Don’t save
            </ButtonV3>
          </div>
        </Row>
      </Modal>
    </>
  );
};
